import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getSectionAccessConfig = () => {
  return httpClient.get(server.SECTION_ACCESS_CONFIG + `/get`);
};

export const getSectionAccessConfig_By_CompanyID = (id) => {
  return httpClient.get(
    server.SECTION_ACCESS_CONFIG + `/get_By_CompanyID/${id}`
  );
};

export const updateSectionAccessConfig = (id, data) => {
  return httpClient.put(server.SECTION_ACCESS_CONFIG + `/${id}`, data);
};

export const createSectionAccessConfig = (data) => {
  return httpClient.post(server.SECTION_ACCESS_CONFIG, data);
};

export const deleteSectionAccessConfig = (id) => {
  return httpClient.delete(server.SECTION_ACCESS_CONFIG + `/${id}`);
};
